"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAuthenticationModule = createAuthenticationModule;
exports.state = void 0;

require("core-js/modules/es6.regexp.split");

var _getters = require("./getters");

var _actions = require("./actions");

var _mutations = require("./mutations");

var _helper = require("@/services/helper/helper.service");

var helper = new _helper.Helper();
var state = {
  isAdmin: false,
  isLogIn: helper.isValidToken(process.env.VUE_APP_AUTH_COOKIE),
  userKey: helper.isValidToken(process.env.VUE_APP_AUTH_COOKIE) ? helper.getCookie(process.env.VUE_APP_AUTH_COOKIE) : '',
  lfToken: helper.isValidToken(process.env.VUE_APP_AUTH_COOKIE) ? helper.getCookie(process.env.VUE_APP_AUTH_COOKIE).split('|')[0] : null,
  lfCustKey: helper.isValidToken(process.env.VUE_APP_AUTH_COOKIE) ? helper.getCookie(process.env.VUE_APP_AUTH_COOKIE).split('|')[1] : null,
  lfAPIToken: helper.isValidToken(process.env.VUE_APP_AUTH_COOKIE) ? helper.getCookie(process.env.VUE_APP_AUTH_COOKIE).split('|')[2] : null,
  userInformation: {},
  userData: {},
  userSetting: {}
};
exports.state = state;
var namespaced = true;
var AuthenticationModule = {
  namespaced: namespaced,
  state: state,
  getters: _getters.getters,
  actions: _actions.actions,
  mutations: _mutations.mutations
};

function createAuthenticationModule() {
  return AuthenticationModule;
}